import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll, postApproval, postBackCustomer } from "./rejectApi";

const initialState = {
  data: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  approval: [],
  backCustomer: [],
};

export const fetchAll = createAsyncThunk("reject/fetchAll", async (payload) => {
  const response = await getAll(payload);
  return response.data;
});

export const createApproval = createAsyncThunk(
  "reject/createApproval",
  async (payload) => {
    const response = await postApproval(payload);
    return response.data;
  }
);
export const createBackCustomer = createAsyncThunk(
  "reject/createBackCustomer",
  async (payload) => {
    const response = await postBackCustomer(payload);
    return response.data;
  }
);

export const rejectSlice = createSlice({
  name: "reject",
  initialState,
  reducers: {
    resetData: (state) => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setApproval: (state, action) => {
      state.approval = action.payload;
    },
    setBackCustomer: (state, action) => {
      state.backCustomer = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(createApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(createApproval.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createApproval.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createBackCustomer.pending, (state) => {
        state.loading = true;
      })
      .addCase(createBackCustomer.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createBackCustomer.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const {
  resetData,
  setSelected,
  setApproval,
  setBackCustomer,
} = rejectSlice.actions;

export const selectData = (state) => state.reject.data;
export const selectLoading = (state) => state.reject.loading;
export const selectError = (state) => state.reject.error;
export const selectPageNo = (state) => state.reject.pageNo;
export const selectPageSize = (state) => state.reject.pageSize;
export const selectTotalRecord = (state) => state.reject.totalRecord;
export const selectSelected = (state) => state.reject.selected;
export const selectApproval = (state) => state.reject.approval;
export const selectBackCustomer = (state) => state.reject.backCustomer;

export default rejectSlice.reducer;
